import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {DataErItem} from '../../core/_models'
import {useAppDispatch, useAppSelector} from '../../../../hooks/redux'
import {setQuery, updateQuery} from '../../slices/erFilterSlice'
import clsx from 'clsx'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<DataErItem>>
}

const ErCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const dispatch = useAppDispatch()
  const query = useAppSelector((state) => state.erFilter)

  const isSelectedForSorting = useMemo(() => {
    return query?.order_by && query.order_by.replace(/\.(asc|desc)$/, '') === id
  }, [query, id])

  const order = useMemo<'asc' | 'desc' | null>(() => {
    if (!query?.order_by) return null
    if (query?.order_by.endsWith('.asc')) return 'asc'
    if (query?.order_by.endsWith('.desc')) return 'desc'
    return null
  }, [query?.order_by])

  const sortColumn = () => {
    if (!isSelectedForSorting) {
      dispatch(updateQuery({...query, order_by: `${id}.asc`}))
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        dispatch(updateQuery({...query, order_by: `${id}.desc`}))
        return
      }

      const {order_by, ...rest} = query || {}
      dispatch(setQuery(rest))
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className, isSelectedForSorting && order !== undefined && `table-sort-${order}`)}
      style={{
        fontSize: '10px',
        fontWeight: 600,
        cursor: 'pointer',
        userSelect: 'none',
      }}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {ErCustomHeader}
